import { CompanyIDs } from '@/core/companyComponents';
import { SelectedProductService } from '@/core/services/selectedProductService';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import * as yup from 'yup';

export const sharedFallbackFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    const selectedProductService = SelectedProductService();
    const shouldRequireLicenseCategory = selectedProductService.getSelectedProductVendor()?.guid === CompanyIDs.INTERSALONIKA;

    return {
        ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity && !discountEntity, discountEntity),
        license_plate: yup.string().required(),
        license_cat: shouldRequireLicenseCategory ? yup.string().required() : yup.string().notRequired(),
    };
};

export const sharedFallbackSchemaBuilder = (...args) => yup.object(sharedFallbackFields(...args));
export default sharedFallbackSchemaBuilder;
